<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
        <header-component :headerTitle="headerText" />
        <v-snackbar
            v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
            <v-layout align-center pr-4>
                <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
                <v-layout column>
                <div>{{ snackbar.text }}</div>
                </v-layout>
            </v-layout>
            <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
                <v-icon>clear</v-icon>
            </v-btn>
        </v-snackbar>
        <v-row justify="center">
        <v-dialog v-model="downloadDialog" persistent max-width="364px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Download</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="downloadDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="2" class="border-opacity-50 m-0"/>
              <v-card-text class="download-email">
                <v-row>
                  <v-col cols="12" sm="4" md="12">
                    <v-text-field label="Email Id" :rules="emailRules" @input="validateEmail" variant="outlined"  v-model="email_id" type="text"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn variant="outlined" class="text-none" size="large" color="primary" @click="downloadDialog = false">Cancel</v-btn>
              <v-btn variant="flat" class="text-none" size="large" color="primary" @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
       </v-row>
        <CommonDialog
          v-model="showDialog"
           title="Add New"
           max-width="700px"
           cancelText="Cancel"
           submitText="Add"
           :submitDisabled="!validateForm"
           @submit="submitForm"
        >
          <template #body>
            <div v-if="headerText === 'Data Validation Values'">
            <v-row>
              <v-col cols="12" sm="6" md="6">
               <v-text-field class="text-left" v-model="enter_id" label="Enter ID" variant="outlined" hide-details></v-text-field>
               <div>
                 <a style="color: #1976d2; cursor: pointer;text-decoration: underline" @click="addMore12">Generate ID</a>
               </div>
              </v-col>
              <v-col cols="12" sm="6" md="6">
               <v-text-field class="text-left" v-model="enter_text" label="Enter Text" variant="outlined" hide-details></v-text-field>
              </v-col>
            </v-row>
          </div>
            <div v-if="headerText === 'Notification Configuration'">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-autocomplete class="text-left" v-model="notification_type" :disabled="edit_recipient" :items="notification_type_items" label="Select Notification Type" variant="outlined" hide-details></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field class="text-left" v-model="ageing_in_days" :disabled="edit_recipient" label="Aging In Days" variant="outlined" hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
               <v-autocomplete class="text-left" v-model="channel" :disabled="edit_recipient" :items="channel_items" label="Channel" variant="outlined" multiple hide-details></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="channel?.includes('SMS')">
              <v-col cols="12" sm="4" md="4">
               <v-autocomplete class="text-left" v-model="sms_template" :disabled="edit_recipient" :items="sms_template_items" item-title="notification_type" item-value="id" label="SMS Template" variant="outlined" hide-details @update:model-value="updateSmsDescription(item)"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="8" md="8">
               <v-text-field class="text-left" v-model="sms_description" label="SMS" disabled variant="outlined" hide-details></v-text-field>
              </v-col>
            </v-row>
            <v-row  v-if="channel?.includes('E-Mail')">
              <v-col cols="12" sm="4" md="4">
               <v-autocomplete class="text-left" v-model="email_template" :disabled="edit_recipient" :items="email_template_items" item-title="notification_type" item-value="id" label="E-Mail Template" variant="outlined" hide-details @update:model-value="updateEmailDescription(item)"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="8" md="8">
               <v-text-field class="text-left" v-model="email_description" disabled label="E - Mail" variant="outlined" hide-details></v-text-field>
              </v-col>
            </v-row>
            <div v-if="channel?.includes('SMS') || channel?.includes('E-Mail')">
            <v-row v-for="(row, index) in rows" :key="index">
              <v-col cols="12" sm="4" md="4">
               <v-text-field class="text-left" v-model="row.name" label="Name" variant="outlined" hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
               <v-text-field class="text-left" v-model="row.email" label="Email" variant="outlined" hide-details></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
               <v-text-field class="text-left" v-model="row.phone" label="Phone" variant="outlined" hide-details></v-text-field>
              </v-col>
            </v-row>
              <v-card-actions>
                 <v-spacer></v-spacer>
                 <span><a style="color: #1976d2; cursor: pointer;text-decoration: underline" @click="addMore"><v-icon size="small">mdi-plus</v-icon>Add More</a></span>
              </v-card-actions>
            </div>            
            </div>
            <div v-if="headerText === 'Return Reason Master'">
             <v-row>
              <v-col cols="12" sm="" md="6">
                  <v-autocomplete class="text-left" v-model="return_types" :items="return_types_items" label="Return Types" variant="outlined" hide-details @update:model-value="fetchList('/api/v2/return_reason_masters/return_subtypes','list1')"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="" md="6">
                  <v-combobox class="text-left" v-model="return_sub_return" :items="return_sub_return_items" label="Return Sub-Return" variant="outlined" hide-details @update:model-value="fetchList('/api/v2/return_reason_masters/return_reasons','list2')"></v-combobox>
              </v-col>
             </v-row>
             <v-row>
              <v-col cols="12" sm="" md="6">
                  <v-combobox class="text-left" v-model="return_reason" :items="return_reason_items" label="Return Reason" variant="outlined" hide-details></v-combobox>
              </v-col>
              <v-col cols="12" sm="" md="6">
                  <v-text-field class="text-left" v-model="return_sub_return_str" label="Return Sub- Reason" variant="outlined" hide-details></v-text-field>
              </v-col>
             </v-row>
            </div>
          </template>
        </CommonDialog>
        <CommonDialog
          v-model="showEditDialog"
           title="Edit"
           max-width="500px"
           cancelText="Cancel"
           submitText="Confirm"
           :submitDisabled="checkFormData"
           @submit="updateForm"
        >
          <template #body>
            <div v-if="headerText === 'Attribute Configuartion'">
              <v-row>
              <v-col cols="12" sm="12" md="12">
              <v-text-field class="text-left" v-model="attribute" label="Attribute" variant="outlined"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete class="text-left" v-model="required" :items="required_items" label="Required" variant="outlined"></v-autocomplete>
              </v-col>
            </v-row>
            </div>
            <div v-if="headerText === 'Field Nomenclature Mapping'">
              <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete class="text-left" v-model="current_title" :items="current_title_items" label="Current Title" variant="outlined" hide-details></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
               <v-text-field class="text-left" v-model="client_defined_title" label="Client Defined Title" variant="outlined"></v-text-field>
              </v-col>
            </v-row>
            </div>
          </template>
        </CommonDialog>
        <v-card class="v-card-100 mt-0">
        <v-card-title class="action-style pt-4 pb-6">
            <!-- Search fields -->
            <v-row class="ma-1">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="mr-4" v-if="headerText === 'Notification Configuration' || headerText === 'Field Nomenclature Mapping' || headerText === 'Define Channel' || 
                   headerText === 'Return Reason Master' || headerText === 'Liquidation Price' || headerText === 'Depreciation Master'"
                    style="max-width: 270px;max-height:52px" variant="outlined" color="primary" @keyup.enter="loadData('search')"></v-text-field>
                    <v-autocomplete class="text-left" v-if="headerText === 'Data Validation Values' || headerText === 'Attribute Configuartion' || headerText === 'Field Nomenclature Mapping'" style="max-width: 270px;max-height:52px" 
                      v-model="data_validation_type" 
                      :items="data_validation_items"
                      item-title="display_name"
                      item-value="name"
                      :label="updateLabel" 
                      hide-details variant="outlined" @update:model-value="loadData('rule_type')"> </v-autocomplete>
                <v-spacer></v-spacer>
                <v-actions>
                  <v-btn v-if="headerText === 'Data Validation Values' && table_data.length > 0" class="mr-2 text-none" variant="flat" @click="openPopup" color="primary" size="x-large">Download</v-btn>
                  <v-btn v-if="headerText === 'Notification Configuration' || headerText === 'Field Nomenclature Mapping' || headerText === 'Define Channel' || headerText === 'Return Reason Master' || headerText === 'Liquidation Price' || headerText === 'Depreciation Master'" 
                      class="mr-2 text-none" variant="flat" @click="openPopup" color="primary" size="x-large">Download</v-btn>          
                  <v-btn v-if="headerText === 'Data Validation Values' || headerText === 'Notification Configuration'" class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" @click="openDialog">Add New</v-btn>
                  <v-btn v-if="headerText === 'Attribute Configuartion' || headerText === 'Field Nomenclature Mapping' || headerText === 'Define Channel' || headerText === 'Return Reason Master' || headerText === 'Liquidation Price' || headerText === 'Depreciation Master'" 
                     class="mr-2 pt-0 text-none"  size="x-large" variant="flat" color="primary" @click="navigateToFileUpload">Upload</v-btn>
                  <v-btn v-if="headerText === 'Return Reason Master'" class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" @click="openDialog">Add</v-btn>
                </v-actions>
            </v-row>
        </v-card-title>        
      </v-card>
      <v-layout column>
        <v-data-table 
            hover
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            :items-per-page="pageSize"
            fixed-header
            height="100%"
            loading-text="Loading Data... Please wait" 
            class="elevation-1"
            return-object
            >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
                <span v-if="header.key === 'action' && headerText === 'Data Validation Values'">
                    <v-icon size="large" color="error" @click="deleteValidationRow(item)">mdi-trash-can-outline</v-icon>
                </span> 
                <span v-else-if="header.key === 'action' && (headerText === 'Attribute Configuartion' || headerText === 'Field Nomenclature Mapping')">
                    <v-icon size="large" color="primary" @click="openEditDialog(item)">mdi-pencil</v-icon>
                </span>
                <span v-else-if="header.key === 'recipient'">
                   <a style="color: #1976d2; cursor: pointer;text-decoration: underline" @click="openRecipient(item)">View</a>
                </span>
                <span v-else-if="header.key === 'floor_price'">
                   <span> {{ formatPrice(item.floor_price) }}</span>
                </span> 
                <span v-else-if="header.key === 'reserve_price'">
                   <span> {{ formatPrice(item.reserve_price) }}</span>
                </span> 
                <span v-else-if="header.key === 'buy_now_price'">
                   <span> {{ formatPrice(item.buy_now_price) }}</span>
                </span>
                <span v-else-if="header.key === 'notification_channels'">
                    <span>{{notification_channels?.length > 0 ?notification_channels.join(', ') : '-' }}</span>
                </span> 
                <span v-else-if="header.key !== 'imags' && item[header.key]">
                    <span v-tooltip="item[header.key]">
                    {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                    </span>
                </span>
                <span v-else>-</span>
                </template>
                <template
                    v-for="key in Object.keys(table_data[0]?.approval_details || {})"
                    v-slot:[`item.approval_details.${key}`]="{ item }" :key="key">
                    {{ item.approval_details?.[key] || '-' }}
                </template>
            <template #bottom></template>
        </v-data-table>
    </v-layout>
    <!-- pagination display -->
     <PaginationComponent
             :pageSize="pageSize"
             :pageSizes="pageSizes"
             :totalCount="totalCount"
             :selected="selected"
             :page="page"
             :totalPages="totalPages"
             @update:pageSize="handlePageSizeChange"
             @update:page="handlePageChange"
             class="mt-2 mb-2"
          />
    </v-card>
</template>
<script setup>
import { ref,reactive, onMounted, getCurrentInstance, computed } from 'vue'
import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import CommonDialog from '@/components/commoncomponents/CommonDialog.vue';
import data from '@/components/api/v2/ClientConfigurationMasters/clientData.json';
import { useStore } from "vuex";
import { useRouter, useRoute } from 'vue-router'
import { email } from '@vuelidate/validators';
    const store = useStore();
    const router = useRouter();
    const route = useRoute();   
    const { proxy } = getCurrentInstance(); 
    const headerText = ref('Data Validation Values')
    const snackbar = reactive({
        visible: false,
        text: '',
        color: '',
        icon: '',
        timeout: 2000,
        position: 'top',
        mode: 'multi-line'
    })
    const data_validation_type = ref(null)
    const data_validation_items = ref(["Issue Reported In Ticket Creation", "Ticket Cancellation Reasons"])
    const selected = ref([]);
    const table_data = ref([]);
    const loading = ref(false);
    const headers = ref([{title: "Category", key: "category", minWidth: "200px"},
                        {title: "Issue Code", key: "issue_code", minWidth: "200px"},
                        {title: "Issue Description", key: "issue_description", minWidth: "200px"},
                        {title: "", key: "action", minWidth: "200px"}]);
    const search_tag = ref('');
    const page = ref(1);
    const pageSize = ref(defaultPageSize);
    const pageSizes = ref(defaultPageSizes);
    const totalCount = ref(0);
    const totalPages = ref(1);
    const showDialog = ref(false);
    const category = ref(null);
    const category_items = ref(["Electronics"]);
    const issue_code = ref("");
    const issue_description = ref("");
    const showEditDialog = ref(false);
    const required = ref(null);
    const required_items = ref(["System Mandatory", "Customer Mandatory", "Optional"]);
    const attribute = ref('');
    const notification_type = ref(null);
    const notification_type_items = ref([]);
    const ageing_in_days = ref('');
    const channel = ref(null);
    const channel_items = ref([]);
    const sms_template = ref(null);
    const sms_template_items = ref([]);
    const sms_description = ref('');
    const email_template = ref(null);
    const email_template_items = ref([]);
    const email_description = ref('');
    const rows = ref([ { name: "", email: "", phone: "" } ]);
    const updateLabel = ref('Select Data Validation Profile');
    const current_title = ref(null);
    const current_title_items = ref(["Select Data Validation Profile", "Select Notification Profile", "Select Field Nomenclature Profile"]);
    const client_defined_title = ref('');
    const return_types = ref(null);
    const return_types_items = ref([]);
    const return_sub_return = ref(null);
    const return_sub_return_items = ref([]);
    const return_reason = ref(null);
    const return_reason_items = ref([]);
    const return_sub_return_str = ref(null);
    const return_sub_return_str_items = ref([]);
    const downloadDialog = ref(false);
    const email_id = ref('');
    const email_format_rule = ref((/^[\w,.]+([\.-]?[\w,.]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email_id.value)) || "Please enter valid Email");
    const isEmailValid = ref(true);
    const emailError = ref('');
    const update_id = ref('');
    const field_items = ref([]);
    const formData = ref({});
    const edit_recipient = ref(false);
    const enter_id = ref('');
    const enter_text = ref([]);


    onMounted(() => {        
        headerText.value = store.state.title;
        if(headerText.value === "Attribute Configuartion"){
            data_validation_items.value= ["Brand Call Log", "Insurance Claim"];
            headers.value = [{title: "Attribute", key: "attribute", minWidth: "200px"},
                             {title: "Required?", key: "required", minWidth: "200px"},
                             {title: "", key: "action", minWidth: "200px"}]
            updateLabel.value = 'Select Entity';
            fetchDataValidationList();
        }else if(headerText.value === "Notification Configuration" || headerText.value === "Field Nomenclature Mapping" || headerText.value === "Define Channel" || headerText.value === "Return Reason Master" || headerText.value === "Liquidation Price" || headerText.value === "Depreciation Master"){
            headers.value = [{title: "Notification Type", key: "notification_type", minWidth: "200px"},
                             {title: "Ageing (Days)", key: "ageing", minWidth: "200px"},
                             {title: "Recipient", key: "recipient", minWidth: "200px"}];
            updateLabel.value = 'Select Front End';
            fetchDataValidationList();
            data_validation_type.value = "Return Creation";
            loadData();

        }else if(headerText.value === 'Data Validation Values'){
            fetchDataValidationList();
        }

    });
    const validateForm = computed(() => {
       if(headerText.value === "Data Validation Values"){
           return (enter_id.value !== '' && enter_text.value !== '');
       }else if(headerText.value === "Return Reason Master"){
           return (return_types.value !== null && return_sub_return.value !== null && return_reason.value !== '' && return_sub_return_str.value !== '');
       }else if(headerText.value === "Notification Configuration"){
          return (notification_type.value !== null && ageing_in_days.value !== '' && channel.value !== null);
       }
    })

    const checkFormData = computed(() => {
        if(headerText.value === "Attribute Configuartion"){
           return (!attribute.value && !required.value);
        }else if(headerText.value === "Field Nomenclature Mapping"){
           return (!current_title.value || !client_defined_title.value);
        }
    })
    const fetchDataValidationList = () => {
      let api = "";
       if(headerText.value === "Attribute Configuartion"){
         api = "/api/v2/attribute_configurations/available_entities";
       }else if(headerText.value === "Field Nomenclature Mapping"){
         api = "/api/v2/front_end_title_masters/available_screens";
       }else{
         api = "/api/v2/data_validation/profiles";
       }
        proxy.$httpSecured.get(api)
        .then(response => {
            if(response.data) {
              if(headerText.value === "Attribute Configuartion"){
                data_validation_items.value = (response.data.entities.length ? response.data.entities : ["Brand Call Log", "Insurance Claim"])
                .map(item => ({
                  name: item,
                  display_name: item
                }));
              }else if(headerText.value === "Field Nomenclature Mapping"){
                data_validation_items.value = response.data.screens
                .map(item => ({
                  name: item,
                  display_name: item
                }));
              }                
              else
                data_validation_items.value = response.data.profiles;
            }else{
                proxy.$toast.error("No Data Found");
            }
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })        
        
    }
    const loadData = () => {
      console.log(store.state.end_point);
        loading.value = true;
        selected.value = [];
        table_data.value = [];
        page.value = 1;
        totalPages.value = 1;
        
        const params = {
            page: page.value,
            per_page: pageSize.value,
        }
        if(search_tag.value != '') {
            params.search = search_tag.value
        }
        if(headerText.value === "Data Validation Values"){
          store.commit("updateTitle", {
            title: headerText.value,
            end_point: `api/v2/data_validation/profiles/issue_reported_in_ticket_creation/values?sort_field=validation_id&sort_direction=asc`,
            file_type: "DataValidationUpload"
          })
        }else if(headerText.value === "Attribute Configuartion"){
          params.entity_name = data_validation_type.value;
          store.commit("updateTitle", {
            title: headerText.value,
            end_point: "/api/v2/attribute_configurations",
            file_type: "AttributeConfigurationUpload",
            entity_name: data_validation_type.value
          })
        }else if(headerText.value === "Field Nomenclature Mapping"){
          params.screen_name = data_validation_type.value;
          store.commit("updateTitle", {
            title: headerText.value,
            end_point: "/api/v2/front_end_title_masters",
            file_type: "FrontEndTitleMasterUpload",
            screen_name: data_validation_type.value
          })
          
        }
        proxy.$httpSecured
        .get(store.state.end_point, headerText.value === "Depreciation Master" ? '' : { params })
        .then(response => {
          if(response.data) {
            let rows = [];
            if(headerText.value === "Data Validation Values"){
                 rows = response.data?.data_validation_values;
            }else if(headerText.value === "Attribute Configuartion"){
                rows = response.data.attributes
            }else if(headerText.value === "Notification Configuration"){
                 rows = response.data.configurations.map((item) => ({
                    ...item,
                     recipient: "View"
                 }));
            }else if(headerText.value === "Field Nomenclature Mapping"){
                 rows = response.data.titles
            }else if(headerText.value === "Define Channel"){
                 rows = response.data.channel_masters;
            }else if(headerText.value === "Return Reason Master"){
                 rows = response.data.return_reason_masters
            }else if(headerText.value === "Liquidation Price"){
                 rows = response.data.liquidation_price_masters
            }else if(headerText.value === "Depreciation Master"){
                rows = response.data.depreciations
            }
            
            table_data.value = rows;
            headers.value = [];
            const unique_keys = new Set();
            rows.forEach((row) => {
               Object.keys(row).forEach((key) => {
                   if(key !== "id" && key !== "created_at" && key !== "updated_at" && key !== "is_active" && key !== "deleted_at" && key !== "db_field_name" && key !== "client_defined_title" && key !== "display_order") {
                       unique_keys.add(key);
                   }
               })
            })
            unique_keys.forEach((key) => {
                headers.value.push({
                    title: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
                    align: 'start',
                    sortable: false,
                    key: key,
                })
            })
            
            if (headerText.value === "Attribute Configuartion" || headerText.value === "Data Validation Values") {
              headers.value.push({
                title: "",
                key: "action",
                minWidth: "100px",
                sortable: false
            })
            }
            if(headers.value.length === 0) {
              headers.value = [{title: "Attribute", key: "attribute", minWidth: "200px"},
                             {title: "Required?", key: "required", minWidth: "200px"},
                             {title: "", key: "action", minWidth: "200px"}]
            }
            totalPages.value = response.data.meta.total_pages;
            totalCount.value = response.data.meta.total_count;
            loading.value = false;
          }else{
            loading.value = false;
            proxy.$toast.error("No Data Found");
          }
        })
        .catch(error => {
            loading.value = false;
            proxy.$toast.error(error.response.data.message);
        })
    }
    const openDialog = () => {
        if(headerText.value === "Data Validation Values"){  
            // getCategory();
            // checkIdByValues();          
            showDialog.value = true;
            field_items.value.forEach(f => {
            if (!(f.name in formData.value)) {
              formData.value[f.name] = ""   // initialize with empty string
            }
          })
        }else if(headerText.value === "Return Reason Master"){
            showDialog.value = true;
            return_types.value = null;
            return_sub_return.value = null;
            return_reason.value = null;
            return_sub_return_str.value = null;
            fetchList("/api/v2/return_reason_masters/return_types", "initially");
        }else{
             getNotifyTypes();
             showDialog.value = true;
             edit_recipient.value = false;
             notification_type.value = null;
             ageing_in_days.value = '';
             channel.value = null;
             sms_template.value = null;
             sms_description.value = '';
             email_template.value = null;
             email_description.value = '';
             rows.value = [ { name: "", email: "", phone: "" } ];
        }
    }
    const downloadFile = (value) => {
       const formData = new FormData();
       if(value === 'submit'){
         formData.append('email_ids', email_id.value);
         formData.append('file_type', store.state.file_type);
         if(headerText.value === "Data Validation Values"){
           formData.append('profile_name', data_validation_type.value);
         }
       }else{
         const ids = selected.value.map(item => item.id);
         ids.forEach(id => formData.append('ids[]', id));
         formData.append('file_type', store.state.file_type);
         if(headerText.value === "Data Validation Values"){
           formData.append('profile_name', data_validation_type.value);
         }
       }

       let url;
       url = "api/v2/bulk_upload/download_info";
       proxy.$httpSecured
       .post(url, formData)
       .then(response => {
         if (response.data) {
          downloadDialog.value = false;
           if(value === 'submit'){
             snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "bottom";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = response.data.message;
             downloadDialog.value = false;
             email_id.value = '';
           }else{
             const url = response.data.url;
             const link = document.createElement("a");
             link.href = url;
             link.download = "";
             document.body.appendChild(link);
             link.click();
             snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "bottom";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = "(CSV File) Downloaded Successfully";
           }
         }
       })
       .catch(error => {
        snackbar.visible = true;
        snackbar.color = "success";
        snackbar.icon = "mdi-check-circle";
        snackbar.mode = "multi-line";
        snackbar.position = "bottom";
        snackbar.timeout = 3000;
        snackbar.title = "Success";
        snackbar.text = error.response.data.message;
       })
    }
    const navigateToFileUpload = () => {
         store.commit("setLotIds", {
          lotIds:'',
          inventoryId: headerText.value,
          action:'first_tab'
        });
        store.commit("config/ADD_HEADER", headerText.value);
        router.push({ name: "LotFileuploadComm" });
    }

    const openEditDialog = (item) => {
        update_id.value = item.id;
        // required_items.value = table_data.value.map(item => item.requirement_type);
        showEditDialog.value = true;
        attribute.value = item.attribute_name;
        required.value = item.requirement_type;
    }
    const openRecipient = (item) => {
        showDialog.value = true;
        update_id.value = item.id;
        edit_recipient.value = true;
        getRecipients();
        getNotifyTypes();
    }
    const getRecipients = () => {
      proxy.$httpSecured
        .get(`/api/v2/notification_configurations/${update_id.value}`)
        .then(response => {
          if(response.data) {
            const config_values = response.data.configuration;

            notification_type.value = config_values.notification_type;
            ageing_in_days.value = config_values.ageing_days;

            channel.value = config_values.notification_channels.map(c => {
              return c.notification_template.channel === "Email" ? "E-Mail" : c.notification_template.channel;
            });

            // Email channel (if exists)
            const emailChannel = config_values.notification_channels.find(c => c.notification_template.channel === "Email");
            if(emailChannel) {
              email_template.value = emailChannel.notification_template.id;
              email_description.value = emailChannel.notification_template.template_text;
            } else {
              email_template.value = null;
              email_description.value = '';
            }

            // SMS channel (if exists)
            const smsChannel = config_values.notification_channels.find(c => c.notification_template.channel === "SMS");
            if(smsChannel) {
              sms_template.value = smsChannel.notification_template.id;
              sms_description.value = smsChannel.notification_template.template_text;
            } else {
              sms_template.value = null;
              sms_description.value = '';
            }

            // Recipients
            rows.value = config_values.notification_recipients.map(r => ({
              name: r.name,
              email: r.email,
              phone: r.phone
            }));

          } else {
            proxy.$toast.error("No Data Found");
          }        
        })
        .catch(error => {
          proxy.$toast.error(error.response?.data?.message || error.message);
        });
    }

    const addMore = () => {
        rows.value.push({ name: "", email: "", phone: "" });
    };
    const handlePageSizeChange = (size) => {
        pageSize.value = size;
        page.value = 1;
        loadData();
    }
    const handlePageChange = (newPage) => {
        page.value = newPage;
        loadData();
    }
    const validateEmail = () => {
        const emails = email_id.value.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(emails.length === 1 && !emailPattern.test(emails[0])) {
          emailError.value = 'Please enter a valid email';
          isEmailValid.value = false
          return;
        }else{
          isEmailValid.value = true
        }
        for (const email of emails) {
          if (!emailPattern.test(email)) {
            emailError.value = 'Please enter valid email ids separated by commas';
            isEmailValid.value = false
            return;
          }else{
            isEmailValid.value = true
          }
        }     
        emailError.value = null;
    }
    const openPopup = () => {
      if(selected.value.length > 0){
        downloadFile('selected')
      }else{
        downloadDialog.value = true;
        email_id.value = store.state.currentUser.email;
        validateEmail(email_id.value)
      }        
    }
    const fetchList = (end_point, condition) => {
      let url;
      const params = {}
      if(condition === 'initially'){
        url = end_point;
      }else if(condition === 'list1'){
        url = end_point;
        params.return_type = return_types.value;
      }else if(condition === 'list2'){
        url = end_point;
        params.return_type = return_types.value;
        params.return_subtype = return_sub_return.value;
      }else if(condition === 'list3'){
        url = end_point;
        params.return_type = return_types.value;
        params.return_subtype = return_sub_return.value;
        params.return_reason = return_reason.value;
      }
      proxy.$httpSecured
      .get(url, { params })
      .then(response => {
        if (response.data) {
          if(condition === 'initially'){            
            return_types_items.value = response.data.return_types.length ? response.data.return_types : [];
          }else if(condition === 'list1'){
            return_sub_return_items.value = response.data.return_subtypes.length ? response.data.return_subtypes : [];
          }else if(condition === 'list2'){
            return_reason_items.value = response.data.return_reasons.length ? response.data.return_reasons : [];
          }else if(condition === 'list3'){
            return_sub_return_str_items.value = response.data.return_sub_reasons.length ? response.data.return_sub_reasons : [];
          }
        } 
      })
      .catch(error => {
        proxy.$toast.error(error.response.data.message);
      })
    }
  const submitForm = () => {
     if(edit_recipient.value){
       updateRecipients()
       return;
     }
      let payload = {};
      let end_point = "";

      if (headerText.value === "Data Validation Values") {
        payload = {
          validation_id: enter_id.value,
          validation_text: enter_text.value,
        };
        end_point = `/api/v2/data_validation/profiles/issue_reported_in_ticket_creation/values`; 
      } else if (headerText.value === "Return Reason Master") {
        payload = {
          return_reason_master: {
            return_type: return_types.value,
            return_subtype: return_sub_return.value,
            return_reason: return_reason.value,
            return_sub_reason: return_sub_return_str.value,
          },
        };
        end_point = "/api/v2/return_reason_masters";
      }else if (headerText.value === "Notification Configuration") {
            const channelsArr = [];

            if (channel.value.includes("SMS")) {
              channelsArr.push({
                channel: "SMS",
                template_id: sms_template.value
              });
            }

            if (channel.value.includes("E-Mail")) {
              channelsArr.push({
                channel: "E-Mail",
                template_id: email_template.value
              });
            }

            payload = {
              notification_configuration: {
                notification_type: notification_type.value,
                ageing_days: ageing_in_days.value,
              },
              channels: channelsArr,
              recipients: rows.value // already array of recipients
            };

            end_point = "/api/v2/notification_configurations";
        }

      proxy.$httpSecured
        .post(end_point, payload)
        .then((response) => {
          if (response.data) {
            showDialog.value = false;
            snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "bottom";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = response.data.message ? response.data.message : "Data saved successfully";
            loadData(headerText.value);
          }
        })
        .catch((error) => {
          const errors = error.response?.data?.errors;
          if (Array.isArray(errors)) {
            proxy.$toast.error(errors[0]);
          } else if (errors && typeof errors === "object") {
            const firstKey = Object.keys(errors)[0];
            const message = errors[firstKey][0];
            proxy.$toast.error(message);
          } else {
            proxy.$toast.error("Something went wrong!");
          }
        });
    };
    const getCategory = () => {
      const api = "/admin/categories";
      proxy.$httpSecured.get(api)
      .then(response => {
          if(response.data) {
              categories_items.value = response.data.categories;
          }else{
              proxy.$toast.error("No Data Found");
          }
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })        
    }

    const updateForm = () => {
       let payload = {};
      let end_point = "";

      if (headerText.value === "Attribute Configuartion") {
        payload = {
          attribute_configuration: {
            requirement_type: required.value,
          },
        };
        end_point = `/api/v2/attribute_configurations/${update_id.value}`; 
      }

      proxy.$httpSecured
        .put(end_point, payload)
        .then((response) => {
          if (response.data) {
            showEditDialog.value = false;
            snackbar.visible = true;
            snackbar.color = "success";
            snackbar.icon = "mdi-check-circle";
            snackbar.mode = "multi-line";
            snackbar.position = "bottom";
            snackbar.timeout = 3000;
            snackbar.title = "Success";
            snackbar.text = "Data Updated Successfully";
            loadData(headerText.value);
          }
        })
        .catch((error) => {
          const errors = error.response?.data?.errors;
          if (errors) {
            const firstKey = Object.keys(errors)[0];
            const message = errors[firstKey][0];
            proxy.$toast.error(message);
          } else {
            proxy.$toast.error("Something went wrong!");
          }
        });
    }
    const deleteValidationRow = (item) => {
        proxy.$httpSecured
        .delete(`/api/v2/data_validation/profiles/issue_reported_in_ticket_creation/values/${item.id}`)
        .then(response => {
            if (response.data) {
                snackbar.visible = true;
                snackbar.color = "success";
                snackbar.icon = "mdi-check-circle";
                snackbar.mode = "multi-line";
                snackbar.position = "bottom";
                snackbar.timeout = 3000;
                snackbar.title = "Success";
                snackbar.text = "Data Deleted Successfully";
                loadData(headerText.value);
            } 
        })
        .catch(error => {
            proxy.$toast.error(error.response.data.message);
        })
    }
    const checkIdByValues = () => {
      proxy.$httpSecured
      .get(`/api/v2/data_validation_profiles/${data_validation_type.value}`)
      .then(response => {
          if(response.data) {
              field_items.value = response.data.fields.sort((a, b) => a.display_order - b.display_order)
          }else{
              proxy.$toast.error("No Data Found");
          }
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })        
    }
    const formatPrice = (value) => {
      if (!value) return "₹0";
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 2
      }).format(value);
    };
    const getNotifyTypes = () => {
      proxy.$httpSecured
      .get(`/api/v2/notification_configurations/notification_types`)
      .then(response => {
          if(response.data) {
              notification_type_items.value = response.data.notification_types.length ? response.data.notification_types : ["Brand Call Log Pending Information"];
              getChannels();
              getSmsTemplates();
              emailTemplate();
          }else{
              proxy.$toast.error("No Data Found");
          }
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })        
    }
    const getChannels = () => {
      proxy.$httpSecured
      .get(`/api/v2/notification_configurations/channels`)
      .then(response => {
          if(response.data) {
              channel_items.value = response.data.channels;
          }else{
              proxy.$toast.error("No Data Found");
          }
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })        
    }
    const getSmsTemplates = () => {
      proxy.$httpSecured
      .get(`/api/v2/notification_configurations/sms_templates`)
      .then(response => {
          if(response.data) {
              sms_template_items.value = response.data.templates;
          }else{
              proxy.$toast.error("No Data Found");
          }
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })        
    }
    const emailTemplate = () => {
      proxy.$httpSecured
      .get(`/api/v2/notification_configurations/email_templates`)
      .then(response => {
          if(response.data) {
              email_template_items.value = response.data.templates;
          }else{
              proxy.$toast.error("No Data Found");
          }
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })        
    }
    const updateSmsDescription = (item) => {      
      sms_description.value = sms_template_items.value.find(x => x.id == sms_template.value).template_text;
    }
    const updateEmailDescription = (item) => {      
      email_description.value = email_template_items.value.find(x => x.id == email_template.value).template_text;
    }
    const updateRecipients = () => {
      proxy.$httpSecured
      .put(`/api/v2/notification_configurations/${update_id.value}/update_recipients`, {
        notification_recipients: rows.value
      })
      .then(response => {
        if (response.data) {
          showDialog.value = false;
          snackbar.visible = true;
          snackbar.color = "success";
          snackbar.icon = "mdi-check-circle";
          snackbar.mode = "multi-line";
          snackbar.position = "bottom";
          snackbar.timeout = 3000;
          snackbar.title = "Success";
          snackbar.text = "Data Updated Successfully";
          loadData(headerText.value);
        } 
      })
      .catch(error => {
          proxy.$toast.error(error.response.data.message);
      })
    }
    const addMore12 = () => {
      enter_id.value = generateRandomId();
    }
    const generateRandomId = () => {
      const randomNum = Math.floor(100000 + Math.random() * 900000); 
       return `VI${randomNum}`;
    };
      
</script>
<style scoped>
    .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 240px) !important;
}
</style>